export default "__VITE_ASSET__CrHiIvqM__"